import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function AboutPage() {
  return <div className="bg-black text-white min-h-screen" data-id="element-213">
      <Header data-id="element-214" />
      <main className="pt-20" data-id="element-215">
        <div className="container mx-auto px-4 py-16" data-id="element-216">
          <h1 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-217">
            About IKHAN<span className="text-red-600" data-id="element-218">FX</span>
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-219">
            <div data-id="element-220">
              <p className="text-xl text-gray-300 mb-6" data-id="element-221">
                IKHANFX was founded with a simple mission: to make professional
                trading education accessible to everyone.
              </p>
              <p className="text-gray-400 mb-6" data-id="element-222">
                Our team of expert traders and educators have decades of
                combined experience in the financial markets. We've distilled
                their knowledge into comprehensive, easy-to-follow classes that
                help traders at all levels improve their skills and results.
              </p>
              <p className="text-gray-400" data-id="element-223">
                Whether you're just starting out or looking to refine advanced
                strategies, our platform provides the tools, resources, and
                community you need to succeed in today's dynamic markets.
              </p>
            </div>
            <div data-id="element-224">
              <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Trading office" className="rounded-lg shadow-lg" data-id="element-225" />
            </div>
          </div>
          <div className="mb-16" data-id="element-226">
            <h2 className="text-3xl font-bold mb-6" data-id="element-227">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-228">
              <div className="bg-zinc-900 p-6 rounded-lg" data-id="element-229">
                <h3 className="text-xl font-bold mb-3" data-id="element-230">Education First</h3>
                <p className="text-gray-400" data-id="element-231">
                  We believe in providing honest, practical education that
                  focuses on sustainable trading strategies rather than
                  get-rich-quick schemes.
                </p>
              </div>
              <div className="bg-zinc-900 p-6 rounded-lg" data-id="element-232">
                <h3 className="text-xl font-bold mb-3" data-id="element-233">Community</h3>
                <p className="text-gray-400" data-id="element-234">
                  Trading can be isolating. We foster a supportive community
                  where members can learn from each other and grow together.
                </p>
              </div>
              <div className="bg-zinc-900 p-6 rounded-lg" data-id="element-235">
                <h3 className="text-xl font-bold mb-3" data-id="element-236">
                  Continuous Improvement
                </h3>
                <p className="text-gray-400" data-id="element-237">
                  Markets evolve, and so do we. We're committed to constantly
                  updating our content and strategies to stay ahead of market
                  changes.
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-238">
            <h2 className="text-3xl font-bold mb-6" data-id="element-239">Our Team</h2>
            <p className="text-gray-300 mb-8" data-id="element-240">
              Meet the experts behind IKHANFX who are dedicated to your trading
              success.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-241">
              <div data-id="element-242">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80" alt="CEO" className="rounded-lg mb-4 aspect-[3/4] object-cover" data-id="element-243" />
                <h3 className="font-bold text-xl" data-id="element-244">Alexander Khan</h3>
                <p className="text-red-600" data-id="element-245">Founder & CEO</p>
              </div>
              <div data-id="element-246">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=988&q=80" alt="COO" className="rounded-lg mb-4 aspect-[3/4] object-cover" data-id="element-247" />
                <h3 className="font-bold text-xl" data-id="element-248">Sarah Johnson</h3>
                <p className="text-red-600" data-id="element-249">Chief Trading Officer</p>
              </div>
              <div data-id="element-250">
                <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80" alt="CTO" className="rounded-lg mb-4 aspect-[3/4] object-cover" data-id="element-251" />
                <h3 className="font-bold text-xl" data-id="element-252">David Park</h3>
                <p className="text-red-600" data-id="element-253">Head of Education</p>
              </div>
              <div data-id="element-254">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1061&q=80" alt="CMO" className="rounded-lg mb-4 aspect-[3/4] object-cover" data-id="element-255" />
                <h3 className="font-bold text-xl" data-id="element-256">Elena Rodriguez</h3>
                <p className="text-red-600" data-id="element-257">Risk Management Specialist</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-258" />
    </div>;
}